'use strict';
var xregexp = require('xregexp');

angular.module('amexReconciliationApp')
  .service('MaskFormatterService',function () {
    var self = this;
    var MASK_REGEXES = {
      'A': '[\\p{Lu}]',
      'a': '[\\p{L}]',
      'B': '[\\p{Lu}\\p{Z}]',
      'b': '[\\p{L}\\p{Z}]',
      'C': '[\\p{Lu}\\p{Nd}]',
      'c': '[\\p{L}\\p{Nd}]',
      'd': '[\\p{Ll}\\p{Z}]',
      'e': '[\\p{Ll}\\p{Nd}\\p{Z}]',
      'l': '[^\\p{Lu}]',
      'M': '[\\p{Lu}\\p{Nd}\\p{Z}]',
      'm': '[\\p{L}\\p{Nd}\\p{Z}]',
      'N': '\\p{Nd}',
      'n': '[\\p{Nd}\\p{Z}]',
      'U': '[^\\p{Ll}]'
    };

    self.stripDelimiters = function (value, schema) {

      var mask = schema.maskPattern;

      var valueArr = _.split(value, '');
      var maskArr = _.split(mask, '');

      for(var i = 0; i < maskArr.length; i++){
        if (!MASK_REGEXES[maskArr[i]] && maskArr[i] === valueArr[i]) {
          valueArr.splice(i,1);
          maskArr.splice(i,1);
          i--;
        }
      }

      return _.trimEnd(_.join(valueArr, ''));
    };

    self.formatForDisplay = function (value, schema) {

      var mask = schema.maskPattern;

      if (!value || !mask || value === '') {
        return value;
      }

      value = _.padEnd(value,mask.length,' ');

      var formattedValue = [];
      var maskArr = _.split(mask, '');
      var valueArr = _.split(value, '');

      while (maskArr.length > 0) {
        var valueCharacter = valueArr.shift();
        var maskMatcher = maskArr.shift();

        var regex = MASK_REGEXES[maskMatcher];
        if (regex !== undefined) {
          formattedValue.push(valueCharacter);
          continue;
        }

        formattedValue.push(maskMatcher);
        if (valueCharacter !== maskMatcher) {
          valueArr.unshift(valueCharacter);
        }
      }

      if(valueArr.length > 0) {
        formattedValue = formattedValue.concat(valueArr);
      }

      return _.trimEnd(_.join(formattedValue, ''));
    };

    self.validateMask = function(value, schema) {

      var mask = schema.maskPattern;

      if (value != null && mask !=null && (value.length > mask.length)){
        return false;
      }

      if (schema.required === false && value === '') {
        return true;
      }

      var paddedValue = _.padEnd(value, mask.length, ' ');

      var valueArr = _.split(paddedValue, '');
      var maskArr = _.split(mask, '');

      valueArr.push('the end');
      maskArr.push('the end');

      var valueCharacter = valueArr.shift();
      var maskCharacter = maskArr.shift();

      while (maskArr.length > 0) {

        if (MASK_REGEXES[maskCharacter] !== undefined) {
          var regex =  xregexp(MASK_REGEXES[maskCharacter]);
          if (regex.test(valueCharacter)) {
            valueCharacter = valueArr.shift();
            maskCharacter = maskArr.shift();
          } else {
            return false;
          }
        } else {
          if (valueCharacter === maskCharacter) {
            valueCharacter = valueArr.shift();
            maskCharacter = maskArr.shift();
          } else {
            maskCharacter = maskArr.shift();
          }

        }
      }
      return true;
    };

    return self;
  });




//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/services/MaskFormatterService.js
// module id = 642
// module chunks = 0